<template>
  <q-page padding>

		<q-alert v-if="noCourses"
			color="secondary"
			icon="class"
			appear
			class="q-mb-sm"
			>
			<div>
				Please add at least one course or assessment to begin seeing how your credits may transfer.
			</div>
		</q-alert>

		<CourseList />

		<AddLearningButton @click="addNewCourse" :visible="addCourseVisible" label="Add Course" />
  </q-page>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { mapMutations, mapGetters } from 'vuex';
import CourseList from '@/components/learning-entry/CourseList.vue';
import AddLearningButton from '@/components/learning-entry/AddLearningButton.vue';

@Component({
	methods: mapMutations('wmct', {
		addCourse: 'ADD_COURSE',
	}),
	computed: mapGetters('wmct', [
		'isAddingCourse',
		'isEditingCourse',
	]),
	components: {
		CourseList,
		AddLearningButton,
	},
})
export default class MyCourses extends Vue {
	private addCourse!: () => Promise<void>;
	private isAddingCourse!: boolean;
	private isEditingCourse!: boolean;

	public async addNewCourse() {
		await this.addCourse();

		(this as any).$scrollToId('course-0');
	}

	public get noCourses() {
		return this.$store.state.wmct.courses.length === 0;
	}

	public get addCourseVisible() {
		return !this.isAddingCourse && !this.isEditingCourse;
	}

	public mounted() {
		window.scrollTo(0, 0);
	}
}
</script>
